import { render, staticRenderFns } from "./TalentTree.vue?vue&type=template&id=0ec5131b&scoped=true"
import script from "./TalentTree.vue?vue&type=script&lang=js"
export * from "./TalentTree.vue?vue&type=script&lang=js"
import style0 from "./TalentTree.vue?vue&type=style&index=0&id=0ec5131b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec5131b",
  null
  
)

export default component.exports